export default "__VITE_ASSET__B_Pa22W5__"